package com.nonopn.skywatcher.common.app.pages.sentinels

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.nonopn.skywatcher.common.app.home.LocalApp
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.push_notification_dialog_text
import com.nonopn.skywatcher.common.app.res.push_notification_dialog_title
import com.nonopn.skywatcher.design.utils.localized
import com.nonopn.skywatcher.design.widgets.PopupConfirm
import eu.codlab.platform.Platform
import eu.codlab.platform.currentPlatform
import korlibs.io.util.UUID

@Composable
fun CheckPushNotificationCompose() {
    val app = LocalApp.current
    val state by app.states.collectAsState()
    val uuid by remember { mutableStateOf(UUID.randomUUID().toString()) }

    if (currentPlatform != Platform.IOS && currentPlatform != Platform.ANDROID) {
        return
    }

    if (state.notificationPermissionState == null || state.notificationPermissionRequested) {
        return
    }

    PopupConfirm(
        uuid,
        Res.string.push_notification_dialog_title.localized(),
        Res.string.push_notification_dialog_text.localized(),
        showCancel = true,
        onDismiss = {
            app.requestPushNotificationPermissionRequested()
        },
        onConfirm = {
            app.requestPushNotificationPermission()
        }
    )
}